import React from "react";

interface Props {
  settings: any;
  setSettings: any;
}
const BikeSharingCalendar = (props: Props) => {
  const {} = props;
  return <></>;
};

export default BikeSharingCalendar;
